import React, { useState, useEffect, useRef } from 'react';

function valuePreview(raw) {
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    const str = JSON.stringify(parsed, null, 2);
    return str.length > 200 ? str.slice(0, 197) + '…' : str;
  } catch (_) {
    return String(raw);
  }
}

export default function FilterCard({
  filter,
  isActive,
  onUse,
  onRename,
  onEdit,
  onDelete,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    function handler(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  const isCustom = filter.type === 'custom';

  if (confirming) {
    return (
      <div
        className={`sfc-card sfc-card--confirming ${
          isActive ? 'sfc-card--active' : ''
        }`}
      >
        <div className="sfc-confirm">
          <p className="sfc-confirm-msg">
            Delete <strong>"{filter.label}"</strong>? This can't be undone.
          </p>
          <div className="sfc-confirm-actions">
            <button
              className="sfc-confirm-btn sfc-confirm-btn--cancel"
              onClick={() => setConfirming(false)}
            >
              Cancel
            </button>
            <button
              className="sfc-confirm-btn sfc-confirm-btn--delete"
              onClick={() => {
                setConfirming(false);
                onDelete(filter.id);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`sfc-card ${isActive ? 'sfc-card--active' : ''}`}>
      <div className="sfc-card-body">
        <div className="sfc-header">
          <span className="sfc-label">{filter.label}</span>
          {isCustom && (
            <div className="sfc-overflow-wrap" ref={menuRef}>
              <button
                className="sfc-overflow-btn"
                onClick={() => setMenuOpen((v) => !v)}
                aria-label="Filter options"
                aria-haspopup="menu"
                aria-expanded={menuOpen}
              >
                ⋯
              </button>
              {menuOpen && (
                <div className="sfc-menu" role="menu">
                  <button
                    className="sfc-menu-item"
                    role="menuitem"
                    onClick={() => {
                      setMenuOpen(false);
                      onRename(filter);
                    }}
                  >
                    Rename
                  </button>
                  <button
                    className="sfc-menu-item"
                    role="menuitem"
                    onClick={() => {
                      setMenuOpen(false);
                      onEdit(filter);
                    }}
                  >
                    Edit filter
                  </button>
                  <button
                    className="sfc-menu-item sfc-menu-item--danger"
                    role="menuitem"
                    onClick={() => {
                      setMenuOpen(false);
                      setConfirming(true);
                    }}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {filter.description && <p className="sfc-desc">{filter.description}</p>}

        <pre className="sfc-preview">{valuePreview(filter.value)}</pre>
      </div>

      <div className="sfc-card-footer">
        <button
          className={`sfc-use-btn ${isActive ? 'sfc-use-btn--active' : ''}`}
          onClick={() => !isActive && onUse(filter)}
          aria-pressed={isActive}
        >
          {isActive ? '✓ Active' : 'Use this filter'}
        </button>
      </div>
    </div>
  );
}
